import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation'
import { Add } from '@mui/icons-material';
import HistoricalSimulation from '../../../components/HistoricalSimulation';
import { useNavigate } from 'react-router';

const SimulationTab = ({ customerId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box py={2} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '24px'
        }}
      >
        <Typography 
          sx={{
            color: '#2C2C2C',
            fontSize: '20px',
            fontWeight: '700'
          }}
        >
          {t('dashboard.simulations')}
        </Typography>
          <Button
            onClick={() => navigate(`/app/simulation?customerId=${customerId}`)}
            variant="contained"
            sx={{
              display: 'flex',
              gap: '6px',
              bgcolor: '#83D84D',
              color: '#2C2C2C',
              px: '20px',
              py: '10px',
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: '#73C43D',
                boxShadow: 'none',
              },
            }}
            >
              <Add sx={{ fontSize: 18 }}/>
              {t('simulation.createNewSimulation')}
          </Button>
      </Box>
      <HistoricalSimulation client_id={customerId} isSecondDesign={true}/>
    </Box>
  );
};

export default SimulationTab;
